module.exports = __webpack_public_path__ + "static/media/yellowBalloon.5188fbff.png";